import React from 'react';
import { DropDown } from './common';
import { connect } from 'react-redux';
import { DuLieuHeThong } from 'api';
import {validatable} from 'components/utils';

class DropDownChonLoaiDoiTuong extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      loaiDonThuID: null,
      data: []
    }
  }

  onChange(e) {
    this.props.onChange(e);
  }

  loadData(loaiDonThuID) {
    let params = {
      loaiDonThu: loaiDonThuID
    }
    DuLieuHeThong.actions.getLoaiDoiTuong.request(params).then(res => {
      if (res.data) {
        // TODO: Use Redux

        this.setState({
          data: res.data
        })
      }
    }).catch(err => {})
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.loaiDonThuID != nextProps.loaiDonThuID) {
      if (nextProps.loaiDonThuID) {
        this.loadData(nextProps.loaiDonThuID);
      } else {
        this.setState({
          data: []
        });
      }
    }
  }

  render() {
    return (
      <DropDown label={this.props.loaiDonThuID == 'DON_TO_CAO' ? 'Đối tượng bị tố cáo' : 'Loại đối tượng'} require={this.props.require} selectedValue={this.props.selectedValue} isValid={this.props.isValid} options={this.state.data} keyName='giaTri' valueName='ten' onChange={this.onChange.bind(this)} placeholder={this.props.placeholder} className={`input-group ${this.props.className}`} bindValidator={this} channel="formTaoDon" name={this.props.name}/>
    )
  }
}

DropDownChonLoaiDoiTuong.defaultProps = {
  className: '',
  onChange: function () {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...',
    name: ''
  }
}

let bindStateToProps = state => {
  return {
  }
}

export default connect(bindStateToProps)(validatable(DropDownChonLoaiDoiTuong));



// WEBPACK FOOTER //
// ./src/components/tt-forms/dropdown-chonloaidoituong.jsx